import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const DietBetLogo = ({ width }) => (
  <svg width={width} height={(353 * width) / 316} viewBox="0 0 316 353">
    <path
      className={styles['dietbet']}
      d="M220.323 85.237c-38.063 19.248-44.637-27.47-39.34-52.973C183.406 20.6 183.282 3.256 164.857.273 148.34-2.4 140.612 15.068 141.65 29.98c.634 9.138 6.58 34.574 28.844 65.746 13.689 19.165 40.157 63.652 6.818 107.518-25.747 33.876-56.64 33.463-80.429 59.584-2.712 2.978-7.33 3.309-10.309.597-31.016-28.23-32.886-66.887-22.72-98.15 12.39-38.107 52.041-63.428 61.63-60.55 3.654 1.097 5.502 5.694.188 11.184-29.922 30.918-40.938 73.08-36.243 101.15.21 1.261 2.024 1.223 2.261-.032 10.711-56.885 38.25-84.69 61.423-101.224 2.88-2.055 3.676-5.994 1.785-8.984-6.59-10.421-24.306-31.68-58.973-31.294C53.43 76.002 0 109.768 0 186.785 0 273.81 76.994 353 107.075 353c22.777 0 31.705-10.14 50.925-10.14S186.148 353 208.925 353C239.005 353 316 273.809 316 186.785c0-87.021-50.043-124.625-95.677-101.548"
    />
  </svg>
);

DietBetLogo.propTypes = {
  width: PropTypes.number.isRequired,
};

export default DietBetLogo;
